<template>
    <div v-if="feedback !== null">
        <div class="row">
            <div class="col-12">
                <div class="form-group m-form__group">
                    <div class="form-group m-form__group">
                        <label>フィードバックのステータス</label>
                        <div
                            class="feedbackLabel"
                            :style="feedbackLabel.css">
                            {{ feedbackLabel.text }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group m-form__group">
                    <label for="opinion">業務配慮についての意見</label>
                    <b-form-textarea
                        v-model="feedback.opinion"
                        :rows="4"
                        :max-rows="10"
                        readonly
                        id="opinion">
                    </b-form-textarea>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group m-form__group">
                    <label for="special_notes">特記事項</label>
                    <b-form-textarea
                        v-model="feedback.special_notes"
                        :rows="4"
                        :max-rows="10"
                        readonly
                        id="special_notes">
                    </b-form-textarea>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group m-form__group">
                    <label for="next_schedule">次回相談予定</label>
                    <input
                        v-model="feedback.next_schedule"
                        readonly
                        class="form-control m-input"
                        id="next_schedule"
                        type="text">
                </div>
            </div>
        </div>

        <div class="mt-3">
            <div
                v-if="!feedback.published_at"
                class="text-muted">
                <div>記録未公開</div>
            </div>
            <div v-else>
                <div class="text-muted">公開日時:&nbsp;{{ publishedAt }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'
    import constants from '../../constants'
    import moment from 'moment-timezone'

    export default {
        props: {
            feedback: {
                type: Object,
                required: true,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                feedbackStatusAll: constants.consultation_feedback.all,
            };
        },

        computed: {
            /**
             * 公開日フォーマット
             *
             * @return {string}
             */
            publishedAt: function () {
                if (this.feedback && this.feedback.published_at) {
                    return moment(this.feedback.published_at).locale('ja').format('YYYY年M月D日(ddd) HH:mm')
                }
                return ''
            },

            /**
             * フィードバックのステータス名
             *
             * @return {object}
             */
            feedbackLabel: function () {
                if (!this.feedback) return ''

                const label = this.feedbackStatusAll.find((status) => {
                    return Number(status.value) === Number(this.feedback.status)
                })

                return label || {}
            },
        },

        created: function () {
            // @todo タブが増えたときに実装（現状はタブ1つなので色を変える意味がない）
            // const exists = !!this.feedback.opinion
            // bus.$emit('update-tab-css', 'consultation_feedback', exists)
        },

        beforeDestroy: function () {
            // @todo タブが増えたときに実装（現状はタブ1つなので色を変える意味がない）
            // bus.$off('update-tab-css')
        },
    }
</script>

<style lang="scss" scoped>
.feedbackLabel {
    width: 90px;
    padding: 3px 0;
    border-radius: 20px;
    color: #fff;
    font-size: 13px;
    text-align: center;
    box-sizing: border-box;
}
</style>
